import { IGenericSelectDataModel } from "@kuika/kuika-cl-model";
import classNames from "classnames";
import * as React from "react";
import { JoinTableEmptyComponent } from "./join-table-empty";
import { JoinTableListComponent } from "./join-table-list";

export interface IJoinTableState {}

export interface IJoinTableProps {
  selectData: IGenericSelectDataModel;
  updateSelectData: (newData: IGenericSelectDataModel) => void;
  isModal?: boolean;
  setDropdownVisibility: (val: boolean) => void;
  handleAddJoinClick?: (tableName: string, tableSchema: string) => void;
}

class JoinTable extends React.PureComponent<IJoinTableProps, IJoinTableState> {
  constructor(props: IJoinTableProps) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <div
        className={classNames({
          "generic-sql__join-table": this.props.selectData.tables.length > 1,
          "generic-sql__join-table--empty": this.props.selectData.tables.length <= 1
        })}
      >
        {this.props.selectData.tables.length === 0 || this.props.selectData.tables.length === 1 ? (
          <JoinTableEmptyComponent
            isModal={this.props.isModal}
            tablesLength={this.props.selectData.tables.length}
            setDropdownVisibility={this.props.setDropdownVisibility}
            handleAddJoinClick={this.props.handleAddJoinClick}
            selectData={this.props.selectData}
          />
        ) : (
          <JoinTableListComponent selectData={this.props.selectData} updateSelectData={this.props.updateSelectData} />
        )}
      </div>
    );
  }
}

export const JoinTableComponent = JoinTable;
